import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export function ImageLightbox({ src, alt, onClose }: { src: string | null; alt?: string; onClose: () => void }) {
  useEffect(() => {
    if (!src) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [src, onClose]);
  if (!src) return null;
  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-ink/95 p-4 animate-fade" onClick={onClose} data-testid="image-lightbox">
      <button className="absolute right-4 top-4 rounded-full bg-white/10 p-2 text-white hover:bg-white/20" onClick={onClose} aria-label="Cerrar" data-testid="lightbox-close-button">
        <X className="h-5 w-5" />
      </button>
      <img src={src} alt={alt || ""} className="max-h-full max-w-full rounded object-contain" onClick={(e) => e.stopPropagation()} />
    </div>,
    document.body,
  );
}
